import { Injectable } from '@angular/core';
import { RESTServiceBase, CacheTypes } from '../../common/service.base';
import { ApiProfileDescriptor } from './model/api.profile';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { ProfileModel } from './model/profile.model';
import { IDataService } from '../common/IDataService';

@Injectable()
export class ProfileService extends RESTServiceBase implements IDataService<ProfileModel> {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'ProfileManagement',
      authService,
      config.PMSConfig
    );

  }

  public async create(profile: ProfileModel): Promise<ProfileModel> {
    return new ProfileModel(await super.post<ApiProfileDescriptor>(profile));
  }

  public async getProfiles(view?: View): Promise<List<ProfileModel>> {
    const profiles = await super.get<List<ApiProfileDescriptor>>(undefined, view);
    profiles.value = profiles.value.map(p => new ProfileModel(p));
    return profiles as List<ProfileModel>;
  }

  async GetList(v: View): Promise<List<ProfileModel>> {
    return await this.getProfiles(v);
  }
  async GetById(id: string): Promise<ProfileModel> {
    return await this.getById(id);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public async update(id: string, profile: ProfileModel): Promise<ProfileModel> {
    return new ProfileModel(await super.put<ApiProfileDescriptor>(id, { profile }));
  }

  public async getById(id?: string): Promise<ProfileModel> {
    return new ProfileModel(await super.get<ApiProfileDescriptor>(id, undefined, undefined, CacheTypes.LongPrivateCache));
  }

  public async getByName(userName: string): Promise<ProfileModel> {
    try {
      const list = await super.get<List<ApiProfileDescriptor>>(undefined, { FilterName: 'UserName', FilterValue: userName }, undefined, CacheTypes.LongPrivateCache);
      return new ProfileModel(list.value[0]);
    } catch (error) {
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/profile/profile.service.ts